import React, { Component } from "react";
import PropTypes from "prop-types";
import InvalidFeedback from "../../../common/invalid_feedback";

class AboutForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: props.name,
      profile: Object.assign({}, props.profile),
      angel: Object.assign({}, props.angel),
      isSaving: false,
      errors: {
        profile: {},
        angel: {}
      }
    };
  }

  onProfileChange = (event) => {
    const { profile } = this.state;
    const field = event.target.name;
    profile[field] = event.target.value;
    this.setState({profile: profile});
  };

  onAngelChange = (event) => {
    const { angel } = this.state;
    const field = event.target.name;
    angel[field] = event.target.value;
    this.setState({angel: angel});
  };

  handleFormSubmit = (event) => {
    event.preventDefault();
    this.setState({isSaving: true});

    const { actions, handleEditButtonClick } = this.props;
    actions.updateUser(this.state).then(() => {
      this.setState({isSaving: false, isEditing: false});
      handleEditButtonClick();
    }).catch(errors => {
      this.setState({errors: errors, isSaving: false});
    });
  };

  render () {
    const { profile, angel, isSaving, errors } = this.state;
    const { is_angel, handleEditButtonClick } = this.props;

    return (
      <form>
        <div className='row form-group'>
          <div className='col-12 col-md-3'>
            <label className='col-form-label' htmlFor='user_profile_attributes_bio'>自己紹介</label>
          </div>
          <div className='col-12 col-md-9'>
            <textarea
              name='bio'
              className={`${errors.profile.bio ? "form-control is-invalid" : "form-control"}`}
              value={profile.bio || ""}
              id='user_profile_attributes_bio'
              rows='10'
              onChange={this.onProfileChange}
            />
            <InvalidFeedback errors={errors.profile.bio} label='自己紹介' />
          </div>
        </div>
        { is_angel === true && (
          <React.Fragment>
            <div className='row form-group'>
              <div className='col-12 col-md-3'>
                <label className='col-form-label' htmlFor='user_angel_attributes_interest'>興味のある事業・サービス</label>
              </div>
              <div className='col-12 col-md-9'>
                <textarea
                  name='interest'
                  className={`${errors.angel.interest ? "form-control is-invalid" : "form-control"}`}
                  value={angel.interest || ""}
                  id='user_angel_attributes_interest'
                  rows='10'
                  onChange={this.onAngelChange}
                />
                <InvalidFeedback errors={errors.angel.interest} label='興味のある事業・サービス' />
              </div>
            </div>
            <div className='row form-group'>
              <div className='col-12 col-md-3'>
                <label className='col-form-label' htmlFor='user_angel_attributes_investment_trend'>投資サイズ</label>
              </div>
              <div className='col-12 col-md-9'>
                <textarea
                  name='investment_trend'
                  className={`${errors.angel.investment_trend ? "form-control is-invalid" : "form-control"}`}
                  value={angel.investment_trend || ""}
                  id='user_angel_attributes_investment_trend'
                  rows='10'
                  onChange={this.onAngelChange}
                />
                <InvalidFeedback errors={errors.angel.investment_trend} label='投資サイズ' />
              </div>
            </div>
          </React.Fragment>
        )}
        <div className='row form-group'>
          <div className='col-12'>
            <input
              type='button'
              disabled={isSaving}
              value={isSaving ? "保存中..." : "保存"}
              className="btn btn-primary float-right"
              onClick={this.handleFormSubmit}
            />
            <input
              type='button'
              disabled={isSaving}
              value='キャンセル'
              className="btn btn-white-primary mr-2 float-right"
              onClick={handleEditButtonClick}
            />
          </div>
        </div>
      </form>
    );
  }
}

AboutForm.propTypes = {
  name: PropTypes.string.isRequired,
  profile: PropTypes.shape({
    bio: PropTypes.string
  }).isRequired,
  angel: PropTypes.shape({
    interest: PropTypes.string,
    investment_trend: PropTypes.string
  }).isRequired,
  actions: PropTypes.objectOf(PropTypes.func).isRequired,
  is_angel: PropTypes.bool.isRequired,
  handleEditButtonClick: PropTypes.func.isRequired
};

export default AboutForm;
